import { useRef, useState } from "react";
import { NodeConfig } from "../../types/nodes";

const useNodeConfigs = () => {
    const [nodeResponseConfigs, setNodeResponseConfigs] = useState<Record<string, Record<string, string>>>({});
    const [nodeConfigs, setNodeConfigs] = useState<Record<string, NodeConfig>>({});
    const nodeConfigsRef = useRef<Record<string, NodeConfig>>({});
    const setNodeConfigsForNodeInRef = (nodeId: string, newNodeConfigs: NodeConfig) => {
        nodeConfigsRef.current[nodeId] = newNodeConfigs;
    }
    const getNodeConfigsForNodeFromRef = (nodeId: string) => nodeConfigsRef.current[nodeId];

    return {
        nodeResponseConfigs,
        setNodeResponseConfigs,
        nodeConfigs,
        setNodeConfigs,
        getNodeConfigsForNodeFromRef,
        setNodeConfigsForNodeInRef,
    };
};

export default useNodeConfigs;